import { render, staticRenderFns } from "./configInfo.vue?vue&type=template&id=51f1b9f2&scoped=true&"
import script from "./configInfo.vue?vue&type=script&lang=js&"
export * from "./configInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f1b9f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2026/QianKunLong/QklAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51f1b9f2')) {
      api.createRecord('51f1b9f2', component.options)
    } else {
      api.reload('51f1b9f2', component.options)
    }
    module.hot.accept("./configInfo.vue?vue&type=template&id=51f1b9f2&scoped=true&", function () {
      api.rerender('51f1b9f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/product/proManage/configInfo.vue"
export default component.exports